import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation UpdateMosaicWidget(
    $tenantId: ID!
    $zoneId: ID!
    $widgetIdentifier: FlexibleIdentifierInput!
    $updates: MosaicWidgetUpdates!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        mosaicDev {
          updateWidget(identifier: $widgetIdentifier, updates: $updates)
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.UpdateMosaicWidgetMutation,
  undefined,
  graphql.schema.UpdateMosaicWidgetMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
